import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';

const CitizenshipDistributionChart = () => {
  const chartData = [
    { name: 'PNG Citizens', value: 456, percentage: 86.5 },
    { name: 'Non-Citizens', value: 52, percentage: 9.9 },
    { name: 'Permanent Residents', value: 19, percentage: 3.6 }
  ];

  const COLORS = ['#C41E3A', '#FFD700', '#059669'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-md p-3 shadow-lg">
          <p className="font-body font-medium text-foreground mb-1">
            {payload?.[0]?.name}
          </p>
          <p className="data-text text-sm text-muted-foreground">
            Count: {payload?.[0]?.value}
          </p>
          <p className="data-text text-sm text-primary font-medium">
            {payload?.[0]?.payload?.percentage}%
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 h-full flex flex-col">
      <div className="flex items-center justify-between mb-4 md:mb-6 gap-2">
        <h3 className="font-heading text-base md:text-lg lg:text-xl font-semibold text-foreground break-words overflow-hidden">
          Citizenship Distribution
        </h3>
        <Icon name="PieChart" size={20} color="var(--color-primary)" className="flex-shrink-0 md:w-6 md:h-6" />
      </div>
      <div className="w-full flex-1 min-h-[280px] md:min-h-[320px] overflow-hidden" aria-label="Citizenship Distribution Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ percentage }) => `${percentage}%`}
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
            >
              {chartData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend
              verticalAlign="bottom"
              height={36}
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 md:mt-6 space-y-2 md:space-y-3">
        {chartData?.map((item, index) => (
          <div key={item?.name} className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 min-w-0 flex-1">
              <div
                className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: COLORS?.[index] }}
              />
              <span className="caption text-xs md:text-sm text-foreground truncate">{item?.name}</span>
            </div>
            <span className="data-text text-xs md:text-sm font-medium text-foreground flex-shrink-0">
              {item?.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CitizenshipDistributionChart;